import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Hero from './components/Hero';
import AlbanianMap from 'components/organisms/AlbanianMap';
import SectionWithArrows from 'components/organisms/SectionWithArrows/SectionWithArrows';
import { BudgetService } from 'services/BudgetService';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {},
  pagination: {
    marginTop: theme.spacing(8),
    display: 'flex',
    justifyContent: 'center',
  },
  albanian: {
    height: 750,
  },
  title: {
    fontSize: '30px',
    fontStyle: 'Roboto-Regular',
    textAlign: 'center',
    color: '#981B49',
  },
  subtitle: {
    fontSize: '15px',
    fontStyle: 'Italic',
    textAlign: 'center',
    color: '#2d3748',
    marginBottom: '50px',
  }
}));

const Budget = (props) => {
  const budgetService = new BudgetService();
  const { className } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const [years, setYears] = useState([]);
  const [pbaPeriods, setPbaPeriods] = useState([]);
  const [monitoringPeriods, setMonitoringPeriods] = useState([]);
  const [chart, setChart] = useState([]);
  const [title, setTitle] = useState('');

  const handleFilterChange = async (name, event, isDefaultCall) => {
    const selectedValue = isDefaultCall ? event : event.target.value;
    switch (name) {
      case 'years':
        setTitle(t('BUDGET.BUDGET_TITLE') + " " + getDescriptionById(selectedValue, years));
        break;
      case 'pbaPeriods':
        setTitle(t('BUDGET.PBA_TITLE') + " " + getDescriptionById(selectedValue, pbaPeriods));
        break;
      case 'monitoringPeriods':
        setTitle(t('BUDGET.BUDGET_MONITORING_TITLE') + " " + getDescriptionById(selectedValue, monitoringPeriods));
        break;
      default:
        break;
    }

    const { data } = await budgetService.budget({
      name,
      value: selectedValue,
    });

    // deselect
    chart.series &&
      chart.series[0].data.forEach((x, i) => {
        x.select(false, false);
      });

    // select
    const citiesMap = {};
    data.forEach((x) => {
      citiesMap[x.municipality_name] = x;
    });

    chart.series &&
      chart.series[0].data.forEach((x, i) => {
        if (citiesMap[x.name]) {
          x.select(true, true);
          x.municipality = citiesMap[x.name];
        }
      });
  };

  const handleOnClick = (e) => {
    // eslint-disable-next-line no-unused-vars
    const { name, selected, municipality } = e;
    if (selected) {
      // download
      download(municipality.zip_path);
    }
  };

  const download = (url) => {
    const documentLink = document.createElement('a');
    documentLink.href = url;
    documentLink.target = '_blank';
    documentLink.download = url.split('/').pop();
    document.body.appendChild(documentLink);
    documentLink.click();
    document.body.removeChild(documentLink);
  };

  useEffect(() => {
    budgetService.years().then(setYears);
    budgetService.monitoringPeriodYears().then(setMonitoringPeriods);
    budgetService.pbaPeriods().then(setPbaPeriods);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function getDescriptionById(id, data) {
    const item = data.find(entry => entry.value === id);
    return item ? item.description : 'Description not found';
  }

  return (
    <div className={className}>
      {/*<Hero onFilterChange={handleFilterChange} years={years} pbaPeriods={pbaPeriods} monitoringPeriods={monitoringPeriods}/>*/}
      {(years.length && pbaPeriods.length && monitoringPeriods.length) ? (
          <Hero
              onFilterChange={handleFilterChange}
              years={years}
              pbaPeriods={pbaPeriods}
              monitoringPeriods={monitoringPeriods}
          />
      ) : (
          <div>Loading...</div>
      )}
      <SectionWithArrows>
        <div className={clsx(classes.title)}>
          {title}
        </div>
        <div className={clsx(classes.subtitle)}>
          {t('BUDGET.MESSAGE')}
        </div>
        <AlbanianMap
            className={clsx(classes.albanian)}
            // selectOnClick={true}
            onClick={handleOnClick}
            onFirstLoad={(chart) => {
              setChart(chart);
            }}
        />
      </SectionWithArrows>
    </div>
  );
};

Budget.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Budget;
